import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ERROR_STATUSES } from '../header-message/server-errors.interceptor';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  injector = inject(Injector);
  private router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService: AuthService = this.injector.get(AuthService);
    if (authService.isAuthenticated()) {
      const token = authService.getToken();
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(request).pipe(
      tap(
        (_) => {},
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === ERROR_STATUSES.UNAUTHORIZED) {
              authService.logout(true);
              this.router.navigate(['/sign-in']);
            }
          }
        },
      ),
    );
  }
}
